import { getUniquePageProducts } from '@app/logic/pages';
import { fetchProductsByIds } from '@app/services/productsRepository';
import { isEmpty } from '@app/utils/isEmpty';
import { useQuery } from '@tanstack/react-query';
import { Cms } from '@typings';
interface Props {
  blocks: Cms.AnyBlock[];
  buyerId?: string;
  enabled: boolean;
}
export const PAGE_PRODUCTS_QUERY_KEY = 'pageProducts';

export const usePageProducts = ({ blocks, buyerId, enabled }: Props) => {
  const uniqueProducts = getUniquePageProducts(blocks);

  return useQuery({
    enabled: !isEmpty(uniqueProducts) && enabled,
    queryFn: async () => fetchProductsByIds(uniqueProducts, buyerId),
    queryKey: [PAGE_PRODUCTS_QUERY_KEY, uniqueProducts, buyerId],
    refetchOnMount: false,
    select: data => {
      return data.products;
    },
  });
};
